import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPromoteSvg } from "./IconPromoteSvg.mjs";
const IconPromote = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPromoteSvg, ...svgProps }) });
export {
  IconPromote
};
